"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIModelUndeployedBy = exports.AIModelDeployedBy = exports.DeploymentStatus = void 0;
var DeploymentStatus;
(function (DeploymentStatus) {
    DeploymentStatus["Deploying"] = "deploying";
    DeploymentStatus["Deployed"] = "deployed";
    DeploymentStatus["Undeploying"] = "undeploying";
    DeploymentStatus["Undeployed"] = "undeployed";
    DeploymentStatus["ErrorDeploy"] = "errorDeploy";
    DeploymentStatus["ErrorUndeploy"] = "errorUndeploy";
})(DeploymentStatus || (exports.DeploymentStatus = DeploymentStatus = {}));
var AIModelDeployedBy;
(function (AIModelDeployedBy) {
    AIModelDeployedBy["ViafoundryManual"] = "viafoundry-manual";
    AIModelDeployedBy["ViafoundryAuto"] = "viafoundry-auto";
    AIModelDeployedBy["Vertex"] = "vertex";
})(AIModelDeployedBy || (exports.AIModelDeployedBy = AIModelDeployedBy = {}));
var AIModelUndeployedBy;
(function (AIModelUndeployedBy) {
    AIModelUndeployedBy["ViafoundryManual"] = "viafoundry-manual";
    AIModelUndeployedBy["ViafoundryAuto"] = "viafoundry-auto";
    AIModelUndeployedBy["Vertex"] = "vertex";
})(AIModelUndeployedBy || (exports.AIModelUndeployedBy = AIModelUndeployedBy = {}));
